import { n as e, t } from "./chunk-useConsent-DC8uStwk.js";
//#region src/entry/insights.js
var n = !1, r = () => {
	typeof window.FS == "function" && window.FS("shutdown");
}, i = () => {
	let e = window.__VENDORS__.fullstory.enabled, t = window.__VENDORS__.fullstory.orgId, n = window.__VENDORS__.fullstory.host || "fullstory.com", r = window.__VENDORS__.fullstory.script || "edge.fullstory.com/s/fs.js";
	if (!(!e || !t)) {
		if (typeof window.FS == "function") {
			window.FS("restart");
			return;
		}
		window._fs_host = n, window._fs_script = r, window._fs_org = t, window._fs_namespace = "FS", window._fs_app_host = "app.fullstory.com", (function(e, t, n, r, i, a, o, s) {
			var c, l, u = (function(t) {
				return !(t in e) || (e.console && e.console.log && e.console.log("FullStory namespace conflict. Please set window[\"_fs_namespace\"]."), !1);
			})(n);
			function d(e) {
				var t, n = [];
				function r() {
					t && (n.forEach(function(e) {
						var n;
						try {
							n = e[t[0]] && e[t[0]](t[1]);
						} catch (t) {
							e[3] && e[3](t);
							return;
						}
						n && n.then ? n.then(e[2], e[3]) : e[2] && e[2](n);
					}), n.length = 0);
				}
				function i(e) {
					return function(n) {
						t || (t = [e, n], r());
					};
				}
				return e(i(0), i(1)), { then: function(e, t) {
					return d(function(i, a) {
						n.push([
							e,
							t,
							i,
							a
						]), r();
					});
				} };
			}
			u && (o = e[n] = (function() {
				var e = function(e, n, r, i) {
					function a(a, o) {
						t(e, n, r, a, o, i);
					}
					i ||= 2;
					var o, s = /Async$/;
					return s.test(e) ? (e = e.replace(s, ""), typeof Promise == "function" ? new Promise(a) : d(a)) : t(e, n, r, o, o, i);
				};
				function t(t, n, r, i, a, o) {
					return e._api ? e._api(t, n, r, i, a, o) : (e.q && e.q.push([
						t,
						n,
						r,
						i,
						a,
						o
					]), null);
				}
				return e.q = [], e;
			})(), s = function(e) {
				function t(t) {
					typeof t[4] == "function" && t[4](Error(e));
				}
				var n = o.q;
				if (n) {
					for (var r = 0; r < n.length; r++) t(n[r]);
					n.length = 0, n.push = t;
				}
			}, (function() {
				(a = t.createElement(r)).async = !0, a.crossOrigin = "anonymous", a.src = "https://" + i, a.onerror = function() {
					s("Error loading " + i);
				};
				var e = t.getElementsByTagName(r)[0];
				e && e.parentNode ? e.parentNode.insertBefore(a, e) : t.head.appendChild(a);
			})(), (function() {
				function e() {}
				function t(e, t, n) {
					o(e, t, n, 1);
				}
				function n(e, n, r) {
					t("setProperties", {
						type: e,
						properties: n
					}, r);
				}
				function r(e, t) {
					n("user", e, t);
				}
				function i(e, t, n) {
					r({ uid: e }, n), t && r(t, n);
				}
				o.identify = i, o.setUserVars = r, o.identifyAccount = e, o.clearUserCookie = e, o.setVars = n, o.event = function(e, n, r) {
					t("trackEvent", {
						name: e,
						properties: n
					}, r);
				}, o.anonymize = function() {
					i(!1);
				}, o.shutdown = function() {
					t("shutdown");
				}, o.restart = function() {
					t("restart");
				}, o.log = function(e, n) {
					t("log", {
						level: e,
						msg: n
					});
				}, o.consent = function(e) {
					t("setIdentity", { consent: !arguments.length || e });
				};
			})(), c = "fetch", l = "XMLHttpRequest", o._w = {}, o._w[l] = e[l], o._w[c] = e[c], e[c] && (e[c] = function() {
				return o._w[c].apply(this, arguments);
			}), o._v = "2.0.0");
		})(window, document, window._fs_namespace, "script", window._fs_script);
	}
};
t(() => i(), () => r(), ["marketing", "analytics"], !1, n), e(() => i(), () => r(), ["marketing", "analytics"], n);
//#endregion
